import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, Box, Grid, Typography, CircularProgress, IconButton,   Card, CardContent } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import apiInstance from '../../../../services/ServiceApi';
import ToastMessagge from '../../../../components/utilities/ToastMessage';

const CargaEstadoCuenta = () => {
 
    const [files, setFiles] = useState([]);  
    const [fileInfo, setFileInfo] = useState(''); 
    const [severity, setSeverity] = useState('success');

    const [loading, setLoading] = useState(false);   
    const [anio, setAnio] = useState(new Date().getFullYear());  
    const [distrito, setDistrito] = useState(null);   
    const [openToast, setOpenToast] = useState(false);
    const [mensajeToast, setMensajeToast] = useState({})
    const hasFiles = files.length > 0;

    const clearFiles = () => {
        setFiles([]);
        setFileInfo('');
    };

    const onDrop = useCallback((acceptedFiles) => {
        setFiles(acceptedFiles); 
        let info = '';
        acceptedFiles.forEach((file) => {
            info += `Nombre: ${file.name}, Tamaño: ${file.size}, Tipo: ${file.type}\n`;
        });
        setFileInfo(info);
    }, []);

    const onUpload = () => {
    
          setLoading(true);
          files.forEach((file) => {
            const formData = new FormData();
                    
            const user = JSON.parse(localStorage.getItem('user'));
            //const blob = new Blob([file], { type: file.type });
            formData.append('file',file);
            formData.append('user', user.id);
            formData.append('anio', anio);
      
            apiInstance
              .post('GetEstadoCuentaAlfin/', formData)
              .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'reporte.xlsx'); // o el nombre de archivo que prefieras
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                setLoading(false);
                setOpenToast(true);
                setMensajeToast({ status: 'Procesamiento terminado' });
                setSeverity('success');
                setFiles([])
                })
              .catch((error) => {
                setLoading(false);
                setOpenToast(true);
                setMensajeToast(error);
                setSeverity('error');
              });
          });
      };
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop});


 
      return (
        <Grid container spacing={3} justifyContent="center" alignItems="center">
            <Grid item xs={12}>
                <Typography variant="h5" align="center" gutterBottom>
                    Subir Archivo
                </Typography>
            </Grid>
            <Grid item xs={12} md={10}>
                <Card>
                    <CardContent>
                        <Grid container spacing={3}>
                            
                            <Grid item xs={12}>
                                <Box {...getRootProps()} sx={{
                                    height: 200,
                                    borderWidth: 2,
                                    borderColor: hasFiles ? 'primary.main' : 'grey.500',
                                    borderStyle: 'dashed',
                                    borderRadius: 2, p: 3,
                                    display: 'flex', flexDirection: 'column',
                                    justifyContent: 'center', alignItems: 'center',
                                    transition: 'border .3s ease-in-out'
                                }}>
                                    <input {...getInputProps()} />
                                    {hasFiles ? (
                                        <>
                                            <CloudUploadIcon color="primary" style={{ fontSize: 40 }} />
                                            <Typography variant="body2" color="textSecondary">{fileInfo}</Typography>
                                        </>
                                    ) : (
                                        <>
                                            <CloudUploadIcon color="disabled" style={{ fontSize: 40 }} />
                                            {isDragActive ? 
                                                <p>Suelta los archivos aquí...</p> : 
                                                <p>Arrastra y suelta archivos aquí, o haz clic para seleccionar archivos</p>}
                                        </>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="center" gap={2}>
                                    {hasFiles && (
                                        <IconButton onClick={clearFiles} color="error">
                                            <DeleteIcon />
                                        </IconButton>
                                    )}
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        onClick={onUpload} 
                                        disabled={loading || !hasFiles }
                                        startIcon={loading ? <CircularProgress size={24} /> : <CloudUploadIcon />}
                                    >
                                        Cargar Archivo
                                    </Button>
                                    <Button 
                                        variant="outlined" 
                                        color="primary" 
                                        href="URL_A_TU_PLANTILLA" 
                                        target="_blank"
                                        startIcon={<DownloadIcon />}
                                    >
                                        Descargar Plantilla
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
             {openToast && <ToastMessagge severity={severity} open={openToast} msg={mensajeToast} onClose={()=>setOpenToast(false)} />}

        </Grid>
    );
};

export default CargaEstadoCuenta;